import React from "react";

const Loading: React.FC = () => {
  return (
    <div id="loading-icon" data-testid="loading-icon">
      <div className="barcode-img" data-testid="loading-barcode"></div>
    </div>
  );
};

export default Loading;
